var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgHr = function SvgHr(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121.93,41.42H99.5a16,16,0,0,0-30.28,0H46.79A10.77,10.77,0,0,0,36.06,52.16V127.3A10.76,10.76,0,0,0,46.79,138h75.14a10.76,10.76,0,0,0,10.73-10.73V52.16A10.77,10.77,0,0,0,121.93,41.42Zm-37.57,0A5.37,5.37,0,1,1,79,46.79,5.39,5.39,0,0,1,84.36,41.42Zm0,21.47A16.1,16.1,0,1,1,68.26,79,16.08,16.08,0,0,1,84.36,62.89Zm32.2,64.41H52.16v-7.52c0-10.73,21.47-16.64,32.2-16.64s32.2,5.91,32.2,16.64Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hr.378758e2.svg";
export { ForwardRef as ReactComponent };